<script setup>
import Timeline from '@/components/home/Timeline.vue';
import Relrank  from '@/components/home/Relrank.vue';
import Product  from '@/components/home/Product.vue';
</script>
<template>
<v-card
	min-height="100vh"
	flat
>
	<v-card-text>
		<v-row>
			<v-col cols="8">
				<Product />
				<Relrank />
			</v-col>
			<v-col>
				<Timeline />
			</v-col>
		</v-row>
	</v-card-text>
</v-card>
</template>
<script>
export default {
  head: {
    title() {
      return {
        inner: 'プレスリリース管理',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
      link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/relcreate.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
  },
}
</script>
